import React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || '');
const MOD = isMac ? 'Cmd' : 'Ctrl';
const ALT = isMac ? 'Option' : 'Alt';

const GROUPS = [
  {
    title: 'General',
    items: [
      ['Save', `${MOD}+S`],
      ['Find and replace', `${MOD}+F`],
      ['Ask AI about the selection', `${MOD}+J`],
      ['Insert a block', '/'],
      ['Page break', `${MOD}+Enter`],
      ['Keyboard shortcuts', `${MOD}+/`],
      ['Undo / Redo', `${MOD}+Z / ${MOD}+Shift+Z`],
    ],
  },
  {
    title: 'Formatting',
    items: [
      ['Bold', `${MOD}+B`],
      ['Italic', `${MOD}+I`],
      ['Underline', `${MOD}+U`],
      ['Strikethrough', `${MOD}+Shift+S`],
      ['Inline code', `${MOD}+E`],
      ['Heading 1-3', `${MOD}+${ALT}+1-3`],
      ['Bulleted / numbered list', `${MOD}+Shift+8 / 7`],
      ['Task list', `${MOD}+Shift+9`],
    ],
  },
  {
    title: 'Reviewing AI changes',
    items: [
      ['Next / previous change', `${ALT}+] / ${ALT}+[`],
      ['Accept change', `${MOD}+Enter`],
      ['Reject change', `${MOD}+Backspace`],
      ['Accept all', `${MOD}+Shift+Enter`],
    ],
  },
];

/**
 * Keyboard shortcut cheat sheet.
 * @param {{open: boolean, onClose: () => void}} props - Props.
 * @returns {JSX.Element}
 */
const ShortcutsDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="editor-shortcuts-title">
    <DialogTitle id="editor-shortcuts-title" sx={{ display: 'flex', alignItems: 'center', pr: 1 }}>
      <Box sx={{ flex: 1 }}>Keyboard shortcuts</Box>
      <IconButton aria-label="Close" onClick={onClose}><Close /></IconButton>
    </DialogTitle>
    <DialogContent sx={{ display: 'grid', gap: 2.5, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
      {GROUPS.map((group) => (
        <Box key={group.title}>
          <Typography sx={{ fontSize: 11.5, fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'text.secondary', mb: 1 }}>
            {group.title}
          </Typography>
          {group.items.map(([label, keys]) => (
            <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 0.5 }}>
              <Typography variant="body2" sx={{ flex: 1 }}>{label}</Typography>
              <Box
                component="kbd"
                sx={{
                  fontFamily: 'inherit',
                  fontSize: 12,
                  px: 0.75,
                  py: 0.25,
                  borderRadius: '6px',
                  border: '1px solid',
                  borderColor: 'divider',
                  bgcolor: 'action.hover',
                  whiteSpace: 'nowrap',
                }}
              >
                {keys}
              </Box>
            </Box>
          ))}
        </Box>
      ))}
    </DialogContent>
  </Dialog>
);

export default ShortcutsDialog;
